// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sp-container {
  min-height: 100vh;
  background-color: #000000;
  display: flex;
  flex-direction: column;
}

.sp-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 60px 40px 80px;
  background-color: #000000;
  color: #ffffff;
  flex: 1 1;
  /* ✔ This makes footer stick to bottom */
}

.sp-title {
  font-size: 48px;
  font-weight: 400;
  margin-bottom: 50px;
  text-align: center;
  color: #ffffff;
}

.sp-intro {
  margin-bottom: 48px;
  font-size: 20px;
  line-height: 1.6;
  color: #ffffff;
  background-color: #000000;
  padding: 0;
  border-left: none;
  text-align: left;
}

.sp-section {
  margin-bottom: 48px;
}

.sp-heading {
  font-size: 25px;
  font-weight: bold;
  color: #f59255;
  margin-bottom: 24px;
}

.sp-section p {
  line-height: 1.6;
  color: #e0e0e0;
  margin-bottom: 16px;
  font-size: 20px;
}

.sp-list {
  list-style: none;
  padding-left: 0;
  margin: 15px 0;
}

.sp-list li {
  padding: 0;
  line-height: 1.6;
  color: #e0e0e0;
  border-left: none;
  padding-left: 0;
  margin-bottom: 16px;
  font-size: 20px;
}

.sp-list li strong {
  color: #f59255;
  font-weight: 600;
}

.sp-email {
  color: #f59255;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
}

.sp-email:hover {
  color: #f59255;
  text-decoration: underline;
}

.sp-divider {
  display: none;
}

.sp-footer {
  margin-top: 48px;
  padding: 0;
  background-color: #000000;
  border-radius: 0;
  text-align: left;
  border: none;
}

.sp-footer p {
  font-size: 20px;
  color: #ffffff;
  margin: 0;
}

/* @media (max-width: 768px) {
  .sp-container {
    padding: 60px 15px 30px;
  }

  .sp-title {
    font-size: 2rem;
  }

  .sp-heading {
    font-size: 1.3rem;
  }

  .sp-intro {
    font-size: 1rem;
    padding: 15px;
  }

  .sp-list li {
    padding-left: 0;
  }
} */

@media (max-width: 768px) {
  /* Container se extra padding hata di hai */
  .sp-container {
    padding: 0; 
  }

  /* Main content mein Terms & Conditions wali exact padding daal di hai */
  .sp-content {
    padding: 40px 20px 60px;
  }

  .sp-title {
    font-size: 2rem;
  }

  .sp-heading {
    font-size: 1.3rem;
  }

  .sp-intro {
    font-size: 1rem;
    padding: 15px;
  }

  .sp-list li {
    padding-left: 0;
  }
}

/* MOBILE POLICY FOOTER (match screenshot) */
@media (max-width: 640px) {
  .sp-policy-footer {
    background: #000000 !important;
    border-top: 1px solid #f59255 !important;
    padding: 12px 0 !important;
    color: #ffffff !important;
  }

  .sp-policy-footer>div {
    gap: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .sp-policy-footer nav {
    width: 100%;
  }

  .sp-policy-footer .sp-footer-links {
    line-height: 1.25;
  }

  .sp-policy-footer nav a {
    color: #ffffff !important;
    font-weight: 700;
    font-size: 12px;
    text-decoration: none;
  }

  .sp-policy-footer .sp-footer-sep {
    margin: 0 8px;
    color: #ffffff;
    font-weight: 700;
  }

  .sp-policy-footer .sp-footer-break {
    flex-basis: 100%;
    height: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/ShippingPolicy.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,SAAO;EACP,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH;EACE,2CAA2C;EAC3C;IACE,UAAU;EACZ;;EAEA,wEAAwE;EACxE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,8BAA8B;IAC9B,wCAAwC;IACxC,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF","sourcesContent":[".sp-container {\r\n  min-height: 100vh;\r\n  background-color: #000000;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.sp-content {\r\n  max-width: 900px;\r\n  margin: 0 auto;\r\n  padding: 60px 40px 80px;\r\n  background-color: #000000;\r\n  color: #ffffff;\r\n  flex: 1;\r\n  /* ✔ This makes footer stick to bottom */\r\n}\r\n\r\n.sp-title {\r\n  font-size: 48px;\r\n  font-weight: 400;\r\n  margin-bottom: 50px;\r\n  text-align: center;\r\n  color: #ffffff;\r\n}\r\n\r\n.sp-intro {\r\n  margin-bottom: 48px;\r\n  font-size: 20px;\r\n  line-height: 1.6;\r\n  color: #ffffff;\r\n  background-color: #000000;\r\n  padding: 0;\r\n  border-left: none;\r\n  text-align: left;\r\n}\r\n\r\n.sp-section {\r\n  margin-bottom: 48px;\r\n}\r\n\r\n.sp-heading {\r\n  font-size: 25px;\r\n  font-weight: bold;\r\n  color: #f59255;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.sp-section p {\r\n  line-height: 1.6;\r\n  color: #e0e0e0;\r\n  margin-bottom: 16px;\r\n  font-size: 20px;\r\n}\r\n\r\n.sp-list {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  margin: 15px 0;\r\n}\r\n\r\n.sp-list li {\r\n  padding: 0;\r\n  line-height: 1.6;\r\n  color: #e0e0e0;\r\n  border-left: none;\r\n  padding-left: 0;\r\n  margin-bottom: 16px;\r\n  font-size: 20px;\r\n}\r\n\r\n.sp-list li strong {\r\n  color: #f59255;\r\n  font-weight: 600;\r\n}\r\n\r\n.sp-email {\r\n  color: #f59255;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.sp-email:hover {\r\n  color: #f59255;\r\n  text-decoration: underline;\r\n}\r\n\r\n.sp-divider {\r\n  display: none;\r\n}\r\n\r\n.sp-footer {\r\n  margin-top: 48px;\r\n  padding: 0;\r\n  background-color: #000000;\r\n  border-radius: 0;\r\n  text-align: left;\r\n  border: none;\r\n}\r\n\r\n.sp-footer p {\r\n  font-size: 20px;\r\n  color: #ffffff;\r\n  margin: 0;\r\n}\r\n\r\n/* @media (max-width: 768px) {\r\n  .sp-container {\r\n    padding: 60px 15px 30px;\r\n  }\r\n\r\n  .sp-title {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .sp-heading {\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .sp-intro {\r\n    font-size: 1rem;\r\n    padding: 15px;\r\n  }\r\n\r\n  .sp-list li {\r\n    padding-left: 0;\r\n  }\r\n} */\r\n\r\n@media (max-width: 768px) {\r\n  /* Container se extra padding hata di hai */\r\n  .sp-container {\r\n    padding: 0; \r\n  }\r\n\r\n  /* Main content mein Terms & Conditions wali exact padding daal di hai */\r\n  .sp-content {\r\n    padding: 40px 20px 60px;\r\n  }\r\n\r\n  .sp-title {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .sp-heading {\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .sp-intro {\r\n    font-size: 1rem;\r\n    padding: 15px;\r\n  }\r\n\r\n  .sp-list li {\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n/* MOBILE POLICY FOOTER (match screenshot) */\r\n@media (max-width: 640px) {\r\n  .sp-policy-footer {\r\n    background: #000000 !important;\r\n    border-top: 1px solid #f59255 !important;\r\n    padding: 12px 0 !important;\r\n    color: #ffffff !important;\r\n  }\r\n\r\n  .sp-policy-footer>div {\r\n    gap: 0 !important;\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n  }\r\n\r\n  .sp-policy-footer nav {\r\n    width: 100%;\r\n  }\r\n\r\n  .sp-policy-footer .sp-footer-links {\r\n    line-height: 1.25;\r\n  }\r\n\r\n  .sp-policy-footer nav a {\r\n    color: #ffffff !important;\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n    text-decoration: none;\r\n  }\r\n\r\n  .sp-policy-footer .sp-footer-sep {\r\n    margin: 0 8px;\r\n    color: #ffffff;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .sp-policy-footer .sp-footer-break {\r\n    flex-basis: 100%;\r\n    height: 0;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
